import { render, staticRenderFns } from "./AgmAffirm.vue?vue&type=template&id=897d5eda&scoped=true"
import script from "./AgmAffirm.vue?vue&type=script&lang=js"
export * from "./AgmAffirm.vue?vue&type=script&lang=js"
import style0 from "./AgmAffirm.vue?vue&type=style&index=0&id=897d5eda&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "897d5eda",
  null
  
)

export default component.exports